import { Injectable } from '@angular/core';
import { AppSettingsService, hd, IUserInfoModel, XSightHttpService } from '@nx-fe/services';
import { Observable } from 'rxjs';

type IWatcherModel = hd.IWatcherDetails;

@Injectable({
    providedIn: 'root'
})
export class WatcherService {

    constructor(private http: XSightHttpService, private appSettings: AppSettingsService) { }

    public getTicketWatchers= (ticketId: number): Observable<IWatcherModel[]> => this.http.get<IWatcherModel[]>(`${this.appSettings.ticketServiceUrl}${ticketId}/watchers`);

    public RemoveWatcher = (ticketId: number, userId: string): Observable<IWatcherModel> => this.http.delete<IWatcherModel>(`${this.appSettings.ticketServiceUrl}${ticketId}/watcher/${userId}`);

    public AddWatcher = (ticketId: number, userId: string): Observable<IWatcherModel> => this.http.post<IWatcherModel>(`${this.appSettings.ticketServiceUrl}${ticketId}/watcher/${userId}`, null);

}
